import axios from 'axios'

const addCountryForPayment = async (data) => {
  console.log('add data', data)
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/assignPaymentToCountry`,
      data,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    console.log('addres', response)
    return response.data.msg
  } catch (error) {
    console.log('adderr', error)
    throw error
  }
}

export default addCountryForPayment
